import styled from 'styled-components';

export const StyledAdministratorManagementLists = styled.div`
  display: flex;
  flex-direction: column;
  height: 90%;

  .table {
    overflow: hidden;
    max-height: 1000px;
    min-height: 375px;

    > div {
      height: 100%;

      > .MuiTableContainer-root {
        height: 80%;
      }
    }
  }
`;

export const StyledUserInfoModal = styled.div`
  .modalBody {
    padding: 28px;

    .modalGroup {
      margin-top: 17px;

      span {
        margin-bottom: 17px;
      }
    }
  }
`;

export const StyledSearchBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0;

  > div {
    display: flex;
    align-items: center;

    &.left {
      flex-wrap: wrap;
      gap: 12px;
    }

    &.right {
      gap: 12px;

      > button {
        white-space: nowrap;
      }
    }
  }
`;

export const StyledSearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StyledSearchLabel = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const StyledHeaderRow = styled.div`
  &:hover {
    color: var(--color-primary-blue) !important;
    background-color: var(--color-off-white) !important;

    * {
      color: var(--color-primary-blue) !important;
      background-color: var(--color-off-white) !important;
    }
  }
`;
